module.exports = __webpack_public_path__ + "img/cutting.7d5efeca.svg";